<div
	class="px-6 pb-12 border border-gray-200 rounded-lg pt-7 text-center"
	aria-hidden="true"
>
	<div class="flex justify-center p-3 bg-red-100 max-w-max mx-auto rounded-xl">
		<uc-exclamation-mark-triangular-svg customStyles="!stroke-red-600" />
	</div>

	<p class="mt-5 text-lg font-semibold text-gray-900">No courses found</p>
	<p class="text-gray-500 mt-2 text-sm">
		There are no courses that match your search. Adjust your filters or try a
		different search term
	</p>

	<div class="flex flex-wrap justify-center gap-2 mt-4">
		@for (pill of filterPills(); track $index) {
			<uc-course-search-filter-pill
				[pill]="pill"
				(removePill)="onRemoveFilter($event)"
			/>
		}
	</div>
</div>
